import type { AccountModel } from './Account'
import Account from './Account'

export type StructureModel = AccountModel

const Structure = Account

export default Structure
